import { createSlice } from '@reduxjs/toolkit';

const getLocalStorageItem = (key) => {
	const item = localStorage.getItem(key);
	return item ? JSON.parse(item) : null;
};

const initialState = {
	dataRentProg: getLocalStorageItem('dataRentProg'),
	updateDataRentProg: null,
	newDataRentProg: null,
	activeDataRentProg: getLocalStorageItem('activeRentProg'),
	isUpdateRentProg: false,
	isLoadingRentProg: false,
	isErrorRentProg: false,
};

const rentProgSlice = createSlice({
	name: 'rentProg',
	initialState,
	reducers: {
		setDataRentProg(state, action) {
			state.dataRentProg = action.payload;
		},
		setNewDataRentProg(state, action) {
			state.newDataRentProg = action.payload;
		},
		setUpdateDataRentProg(state, action) {
			state.updateDataRentProg = action.payload;
		},
		setIsUpdateRentProg(state, action) {
			state.isUpdateRentProg = action.payload;
		},
		setIsLoadingRentProg(state, action) {
			state.isLoadingRentProg = action.payload;
		},
		setActiveDataRentProg(state, action) {
			state.activeDataRentProg = action.payload;
		},
		setIsErrorRentProg(state, action) {
			state.isErrorRentProg = action.payload;
		},
	},
});

export const {
	setDataRentProg,
	setNewDataRentProg,
	setUpdateDataRentProg,
	setIsUpdateRentProg,
	setActiveDataRentProg,
	setIsLoadingRentProg,
	setIsErrorRentProg,
} = rentProgSlice.actions;

export default rentProgSlice.reducer;
